import type {
  ClientAdminsStressAssessmentAnswer,
  StressAssessmentCategory,
} from '@fukuri-admins/apis/client/gen/model';
import { convertAnswersByCategory, createCategoryTitleMap } from './logics/converter';
import { StressAssessmentAnswerTablePresentation } from './presentations';

type Props = {
  answers: ClientAdminsStressAssessmentAnswer[];
  categories?: StressAssessmentCategory[];
};

export const StressAssessmentAnswerTable: React.FC<Props> = ({ answers, categories }) => {
  const answersByCategory = convertAnswersByCategory(answers);
  const categoryTitleMap = createCategoryTitleMap(categories);

  return (
    <StressAssessmentAnswerTablePresentation
      answersByCategory={answersByCategory}
      categoryTitleMap={categoryTitleMap}
      totalCount={answers.length}
      itemCount={answers.length}
    />
  );
};
